<input type="file" [disabled]="disableUpload" placeholder="{{'activity_edition.point_img_upload' | translate}}" (change)="onFileSelected($event)"/>
